<template>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
        <div
            class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
            <div class="d-flex align-items-center">
                <form class="search-box position-relative me-15" @submit.prevent="rechercher">
                    <input type="text" name="mot" v-model="searchTerm" @keyup="rechercher"
                        class="form-control shadow-none text-black rounded-0 border-0"
                        placeholder="Rechercher une correction" />
                    <button type="submit" class="bg-transparent text-primary transition p-0 border-0">
                        <i class="flaticon-search-interface-symbol"></i>
                    </button>
                </form>
            </div>
        </div>
        <div class="card-body p-15 p-sm-20 p-md-25">
            <div class="table-responsive">
                <table class="table text-nowrap align-middle mb-0">
                    <thead>

                        <tr>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Référence du Besc
                            </th>
                            <th v-if="isAdmin || isAgent" scope="col"
                                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Date et heure d’émission de la demande.
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Date limite pour la correction
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Message de réponse
                            </th>
                            <th v-if="isAdmin || isAgent" scope="col"
                                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Status
                            </th>
                            <th v-if="isAdmin || isAgent" scope="col"
                                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Représentation structurée
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Message explicatif adressé au demandeur
                            </th>
                            <th v-if="isAdmin || isAgent" scope="col"
                                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Date et heure de la réponse
                            </th>
                            <th v-if="isAdmin || isAgent" scope="col"
                                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Référence de la tâche de validation
                            </th>

                            <!-- <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Utilisateur
                            </th> -->
                            <th  v-if="isAgent" scope="col"
                                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0">
                                Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(correction, index) in corrections" :key="index">
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ correction.besc?.refbesc }}
                            </td>
                            <td v-if="isAdmin || isAgent" class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ format(correction?.requested_at) }}
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ format(correction?.due_date) }}
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ correction.response_message ||
                                    'Veuillez laisser un message après avoir effectué les modifications demandées' }}
                            </td>
                            <td v-if="isAdmin || isAgent" class="shadow-none lh-1 fw-medium text-black-emphasis">
                                <span v-html="getStatusBadgeClass(correction?.status)"></span>
                            </td>
                            <td v-if="isAdmin || isAgent" class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ correction.fields_concerned }}
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ correction.message_to_requester }}
                            </td>
                            <td v-if="isAdmin || isAgent" class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ format(correction.responded_at) || 'Rien a signalé pour le moment' }}
                            </td>

                            <td v-if="isAdmin || isAgent" class="shadow-none lh-1 fw-medium text-black-emphasis">
                                <span v-html="getStatusTaskClass(correction.validationtasks?.status)"></span>
                                <!-- {{ correction.validationtasks.reftask }} -->
                            </td>
                            <!-- <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ correction.user.nom }} {{ correction.user.prenom }}
                            </td> -->
                            <td v-if="isAgent || isTransitaire"
                                class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0">
                                <div class="dropdown">
                                    <span class="badge text-white bg-primary fs-15 dropdown-toggle"
                                        data-bs-toggle="dropdown" aria-expanded="false">
                                        Actions
                                        <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                                    </span>
                                    <ul class="dropdown-menu">
                                        <li v-if="isAgent">
                                            <router-link
                                                :to="{ name: 'EditCorrectionRequestPage', params: { id: correction.id } }"
                                                class="dropdown-item d-flex align-items-center"><i
                                                    class="flaticon-pen lh-1 me-8 position-relative top-1"></i>Modifier</router-link>
                                        </li>
                                        <li v-if="isAgent">
                                            <a class="dropdown-item d-flex align-items-center"
                                                href="javascript:void(0);" @click="validerCorrection(correction)">
                                                <i class="flaticon-check lh-1 me-8 position-relative top-1"></i>
                                                Valider la correction
                                            </a>
                                        </li>
                                        <li v-if="isTransitaire">
                                            <a class="dropdown-item d-flex align-items-center"
                                                href="javascript:void(0);" @click="openResponseModal(correction)">
                                                <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>
                                                Répondre
                                            </a>
                                        </li>
                                        <li v-if="isTransitaire && correction.response_message">
                                            <a class="dropdown-item d-flex align-items-center"
                                                href="javascript:void(0);" @click="openEditResponseModal(correction)">
                                                <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>
                                                Modifier la réponse
                                            </a>
                                        </li>

                                        <li v-if="isAgent || isTransitaire">
                                            <a class="dropdown-item d-flex align-items-center"
                                                href="javascript:void(0);"
                                                @click="suppression(correction.id, correction, 'correction', 'correctionRequest')">
                                                <i class="flaticon-delete lh-1 me-8 position-relative top-1"></i>
                                                Supprimer
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">

                <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit"
                    @paginate="handlePaginate" />

            </div>
        </div>
    </div>
    <div class="modal fade show" tabindex="-1" style="display: block;" v-if="showResponseModal">
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content">

                <div class="modal-header">
                    <h5 class="modal-title">
                        {{ isEditMode ? 'Modifier la réponse' : 'Répondre à la demande de correction' }}
                    </h5>
                    <button type="button" class="btn-close" @click="showResponseModal = false"></button>
                </div>

                <div class="modal-body">
                    <div class="mb-3">
                        <label class="form-label fw-semibold">
                            Message de réponse
                        </label>
                        <textarea v-model="responseMessage" class="form-control" rows="5"
                            placeholder="Saisissez votre réponse..."></textarea>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-secondary" @click="showResponseModal = false">
                        Annuler
                    </button>
                    <button class="btn btn-primary" @click="submitResponse">
                        {{ isEditMode ? 'Enregistrer les modifications' : 'Envoyer la réponse' }}
                    </button>
                </div>

            </div>
        </div>
    </div>

    <!-- backdrop -->
    <div class="modal-backdrop fade show" v-if="showResponseModal"></div>

</template>
<script lang="ts">

import { defineComponent, onMounted, ref, watch, computed } from "vue";

import ApiService from "../../services/ApiService";
import { format_date, suppression, error } from "../../utils/utils";
import axios from 'axios';
import Swal from "sweetalert2";
import PaginationComponent from '../../components/Utilities/Pagination.vue';
import JwtService from "../../services/JwtService";
import { TypeFretPaiement } from "@/models/TypeFretPaiement";
import AddModalValidationTask from "./AddModalValidationTask.vue";
import { ValidationTask } from "@/models/ValidationTask";
import AddModalValidationCheck from "./AddModalValidationCheck.vue";
import { ValidationCheck } from "@/models/ValidationCheck";
import AddModalCorrectionRequest from "./AddModalCorrectionRequest.vue";
import { CorrectionRequest } from "@/models/CorrectionRequest";
import { formatDate } from "@fullcalendar/core";
import { useAuthStore } from "@/services/auth";
import { useRoute, useRouter } from "vue-router";

export default defineComponent({
    name: "ListeCorrectionRequest",
    components: {
        PaginationComponent
    },
    setup: () => {
        // const modules = {

        // };

        const corrections = ref<Array<CorrectionRequest>>([]);
        const correction = ref<CorrectionRequest>();
        const selectedItem = ref(0);
        const showResponseModal = ref(false)
        const selectedCorrection = ref<any>(null)
        const responseMessage = ref("")

        // const openResponseModal = (correction: any) => {
        //     selectedCorrection.value = correction
        //     responseMessage.value = correction.response_message || ""
        //     showResponseModal.value = true
        // }

        const openResponseModal = (correction: any) => {
            selectedCorrection.value = correction;
            responseMessage.value = "";
            showResponseModal.value = true;
            isEditMode.value = false; // Important : mode création
        };
        const router = useRouter();
        const route = useRoute();
        // const correctionId = route.params.id

        const authStore = useAuthStore()
        const userId = authStore.user.id

        const isAdmin = computed(() => {
            const user = JwtService.getUser() as any;
            return user?.roles?.includes('Administrateur') ?? false;
        });

        const isAgent = computed(() => {
            const user = JwtService.getUser() as any;
            return user?.roles?.includes('Agent') ?? false;
        });
        const isTransitaire = computed(() => {
            const user = JwtService.getUser() as any;
            return user?.roles?.includes('Transitaire')

        })
        const isEditMode = ref(false);

        const openEditResponseModal = (correction: any) => {
            selectedCorrection.value = correction;
            responseMessage.value = correction.response_message || "";
            showResponseModal.value = true;
            isEditMode.value = true; // On indique qu'on est en édition
        };
        // BEGIN PAGINATE
        const searchTerm = ref('');
        const page = ref(1);
        const totalPages = ref(0);
        const limit = ref(10);
        const totalElements = ref(0);

        const format = (d) => d ? formatDate(d) : "";

        const handlePaginate = ({ page_, limit_ }) => {
            try {
                page.value = page_;
                getAllCorrection(page_, limit_);
            } catch (error) {
                //
            }
        };

        function rechercher() {
            getAllCorrection(page.value, limit.value, searchTerm.value);
        }
        // END PAGINATE

        // const submitResponse = async () => {
        //     const user = JwtService.getUser();
        //     if (!user) {
        //         Swal.fire({
        //             icon: 'error',
        //             title: 'Erreur',
        //             text: "Utilisateur non connecté",
        //         });
        //         return;
        //     }
        //     if (!responseMessage.value.trim()) {
        //         Swal.fire({
        //             icon: 'warning',
        //             title: 'Attention',
        //             text: "Le message de réponse est obligatoire",
        //         });
        //         return;
        //     }

        //     console.log("ID de la correction :", selectedCorrection.value?.id);
        //     try {
        //         const response = await ApiService.patch(
        //             `/correction/${selectedCorrection.value?.id}/respond`,
        //             {
        //                 response_message: responseMessage.value,
        //                 userId: user.userId,
        //             }
        //         );
        //         selectedCorrection.value.response_message = responseMessage.value;
        //         showResponseModal.value = false;
        //         responseMessage.value = '';

        //         Swal.fire({
        //             icon: 'success',
        //             title: 'Réponse envoyée',
        //             text: "La réponse à la demande de correction a été enregistrée avec succès",
        //             timer: 2000,
        //             showConfirmButton: false,
        //         });
        //     } catch (error: any) {
        //         console.error("Erreur lors de l'envoi :", error);
        //         Swal.fire({
        //             icon: 'error',
        //             title: 'Erreur',
        //             text: error?.response?.data?.message || "Impossible d'envoyer la réponse",
        //         });
        //     }
        // };

        const submitResponse = async () => {
            const user = JwtService.getUser();
            if (!user) {
                Swal.fire({
                    position: "top-end",
                    icon: 'error',
                    title: 'Erreur',
                    text: "Utilisateur non connecté",
                    toast: true,

                });
                return;
            }
            if (!responseMessage.value.trim()) {
                Swal.fire({
                    position: "top-end",
                    icon: 'warning',
                    title: 'Attention',
                    text: "Le message de réponse est obligatoire",
                    toast: true,
                    customClass: {
                        icon: 'fix-icon'
                    }
                });
                return;
            }

            try {
                if (isEditMode.value) {
                    await ApiService.put(`/correction/${selectedCorrection.value?.id}`, {
                        response_message: responseMessage.value.trim()
                    });
                } else {
                    await ApiService.patch(`/correction/${selectedCorrection.value?.id}/respond`, {
                        response_message: responseMessage.value.trim(),
                        userId: user.userId
                    });
                }
                selectedCorrection.value.response_message = responseMessage.value.trim();

                // Rafraîchissement complet de la liste pour être sûr
                getAllCorrection(page.value, limit.value, searchTerm.value);

                // Fermeture modale
                showResponseModal.value = false;
                responseMessage.value = '';

                // Message adapté
                Swal.fire({
                    position: "top-end",
                    toast: true,
                    icon: 'success',
                    title: 'Succès',
                    text: isEditMode.value
                        ? "Votre réponse a été modifiée avec succès"
                        : "Votre réponse a été envoyée avec succès",
                    timer: 2500,
                    showConfirmButton: false,
                });
            } catch (error: any) {
                console.error("Erreur :", error);
                Swal.fire({
                    toast: true,
                    position: "top-end",
                    icon: 'error',
                    title: 'Erreur',
                    text: error?.response?.data?.message || "Impossible d'enregistrer la réponse",
                });
            }
        };

        const validerCorrection = async (correction: any) => {
            const result = await Swal.fire({
                toast: true,
                position: "top-end",
                title: 'Êtes-vous sûr ?',
                text: "Vous allez valider les corrections apporter à ce BESC'.",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Oui, valider',
                cancelButtonText: 'Annuler'
            });

            if (result.isConfirmed) {
                try {
                    await axios.patch(`/correction/${correction.id}/status`, {
                        status: 'Terminée',
                    });
                    correction.status = 'Terminée';

                    // Message succès via SweetAlert
                    await Swal.fire('Validée !', 'La correction a été validée.', 'success');
                } catch (error) {
                    console.error(error);
                    await Swal.fire('Erreur', 'Impossible de valider la correction.', 'error');
                }
            }
        };
        function getAllCorrection(page = 1, limi = 10, searchTerm = '') {
            const user = JwtService.getUser();
            console.log("user:", user);
            if (!user) return error("Utilisateur non connecté");
            const userId = user.userId.replace(/\/+$/, '').trim();
            if (!userId) return error("Utilisateur non connecté");
            return ApiService.get(`corrections?page=${page}&limit=${limi}&searchTerm=${searchTerm}&userCreationId=${userId}`)
                .then(({ data }) => {
                    console.log("data", data)
                    corrections.value = data.data.data;
                    totalPages.value = data.data.totalPages;
                    limit.value = data.data.limit;
                    totalElements.value = data.data.totalElements;
                })
                .catch(({ response }) => {
                    error(response.data.message)
                });
        }

        const getStatusBadgeClass = (value: string | null | undefined): string => {
            if (!value) {
                return '<span class="badge bg-secondary">Inconnu</span>';
            }
            switch (value) {
                case 'OPEN':
                    return '<span class="badge bg-primary text-white">Ouvert</span>';

                case 'ANSWERED':
                    // return '<span class="badge bg-success text-white">Traité</span>';
                    return '<span class="badge bg-secondary text-white">Répondu</span>';

                case 'CANCELLED':
                    return '<span class="badge bg-info text-white">Annulé</span>';
                    
                case 'COMPLETED':
                    return '<span class="badge bg-success text-white">Terminée</span>';

                case 'EXPIRED':
                    // return '<span class="badge bg-danger text-white">Expiré</span>';
                    return '<span class="badge bg-warning text-dark">Expiré</span>';


                default:
                    return `<span class="badge bg-light text-dark">${value}</span>`;
            }
        };

        const getStatusTaskClass = (value: string | null | undefined): string => {
            if (!value) {
                return '<span class="badge bg-secondary">Inconnu</span>';
            }

            switch (value) {
                case 'PENDING':
                    return '<span class="badge bg-warning text-dark">En attente</span>';

                case 'IN_PROGRESS':
                    return '<span class="badge bg-primary text-white">En cours</span>';

                case 'COMPLETED':
                    return '<span class="badge bg-success text-white">Terminée</span>';

                case 'RETURNED_FOR_CORRECTION':
                    return '<span class="badge bg-orange text-white">Retour correction</span>';

                case 'CANCELLED':
                    return '<span class="badge bg-danger text-white">Annulée</span>';

                default:
                    return `<span class="badge bg-light text-dark">${value}</span>`;
            }
        };
        onMounted(() => {
            getAllCorrection();
        });

        function moddifier(EditCorrection: CorrectionRequest) {
            correction.value = EditCorrection;
            selectedItem.value = EditCorrection.id;
        }
        const recharger = () => {
            getAllCorrection();
        };

        const privileges = ref<Array<string>>(JwtService.getPrivilege());

        const checkPermission = (name) => {
            return privileges.value.includes(name);
        }
        return {
            // modules,
            format,
            checkPermission,
            selectedItem,
            corrections,
            recharger,
            suppression,
            moddifier,
            page,
            totalPages,
            limit,
            totalElements,
            getAllCorrection,
            handlePaginate,
            searchTerm,
            isAdmin,
            isTransitaire,
            validerCorrection,
            submitResponse,
            responseMessage,
            isAgent, isEditMode,
            showResponseModal, openEditResponseModal,
            rechercher, getStatusBadgeClass, getStatusTaskClass, openResponseModal
        };
    },
});
</script>
<style scoped>
.fix-icon {
    margin: 0 auto !important;
}
</style>
